import {useUiLayoutStore} from '@frontend/stores'

// Является ли текущий размер экрана мобильным?
export function useIsMobileScreen(): boolean {
    return useUiLayoutStore(
        state => state.deviceType === 'mobile'
    )
}
